<!--  

FILTRO DE FUNIL, USUARIOS, EQUIPES UTILIZADO NOS PAINEIS DE NEGOCIOS, PESSOAS E ORGANIZACOES

-->



<script>

// import CrmFunilNovo from './crm-pessoa-novo-form'
import { SysVars } from '../main';

export default {
    props: {
      params: Object,
      pessoas: Boolean,
      organizacao: Boolean,
      negocios: Boolean,
      leads: Boolean,
    },

    data () {
        return {

            arrNegocios: [
                { id: 0, label: 'Negócios Abertos' },
                { id: 1, label: 'Negócios Perdidos' },
                { id: 2, label: 'Negócios Fechados' },
                { id: 3, label: 'Negócios Estagnados' },
                { id: 4, label: 'Negócios Sem Agenda' },
            ],

            arrEquipes: [],

            arrUsuarios: [],

            arrFunil: [
            ],

            arrContatos: [
                { id: 0, label: 'Todos' },
                { id: 1, label: 'Com negócio em aberto' },
                { id: 2, label: 'Com atividade pendente' },
                { id: 9, label: 'Excluídos' },
            ],  

            arrLeads: [
                { id: 0, label: 'Todos' },
                { id: 1, label: 'Sem atividades' },
                { id: 2, label: 'Atrasados' },
                { id: 3, label: 'Com atividades' },
                { id: 4, label: 'Arquivados' },
            ],  

            arrOrgs: [
                { id: 0, label: 'Todas' },
                { id: 1, label: 'Com negócio em aberto' },
                { id: 2, label: 'Com atividade pendente' },
                { id: 9, label: 'Excluídas' },
            ],  

            indexFiltroSelected: 0,
            indexUsuarioSelected: 0,
            indexEquipeSelected: 0,
            indexFunilSelected: 0,
            indexContatoSelected: 0,
            indexOrgSelected: 0,

            codusuario: null,
            codequipe: null,

            filtroSelected: null,
            filtroContatoSelected: null,
            filtroOrgSelected: null,
            funilSelected: null,
        }
    },

    components: {
    },

    computed: {
        showFunil: function () {
            return this.negocios
        },

        showNegocios: function () {
            return this.negocios
        },

        showPessoas: function () {
            return this.pessoas
        },

        showLeads: function () {
            return this.leads
        },

        showOrganizacao: function () {
            return this.organizacao
        },

        labelNegocios: function () {
            return this.arrNegocios[this.indexFiltroSelected].label
        },
        
        usuarioLabel: function () {
            if (this.arrUsuarios.length > 0)
                return this.arrUsuarios[this.indexUsuarioSelected].label
            else
               return null
        },

        equipeLabel: function () {
            if (this.arrEquipes.length > 0)
                return this.arrEquipes[this.indexEquipeSelected].label
            else
               return null
        },

        funilLabel: function () {
            if (this.arrFunil.length)
               return this.arrFunil[this.indexFunilSelected].label
            else
               return null
        },

        labelContato: function () {
            return this.arrContatos[this.indexContatoSelected].label
        },

        labelOrg: function () {
            return this.arrOrgs[this.indexOrgSelected].label
        },

        configCrm: function () {
            return this.$store.getters.getConfigCrm
        },

        usuarioList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.usuarios_filtro
            else
                return []
        },

        equipeList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.equipes
            else
                return []
        },

        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },
    },

    watch: {
        configCrm: function () {
            this.preparaFiltro()
        }

    },

    filters: {

    },

    methods: {
        handleChangeUsuario (index) {
            this.indexUsuarioSelected = index
            this.codusuario = this.arrUsuarios[index].id
            if (this.codusuario == -1)
              this.codusuario = null
            this.$emit('changeUsuario', this.codusuario)
        },

        handleChangeFiltro (index) {
            this.indexFiltroSelected = index
            this.filtroSelected = this.arrNegocios[index]
            this.$emit('changeFiltro', this.filtroSelected.id)
        },

        handleChangeContatos (index) {
            this.indexContatoSelected = index
            this.filtroContatoSelected = this.arrContatos[index]
            this.$emit('changeFiltroContatos', this.filtroContatoSelected.id)
        },

        handleChangeLeads (index) {
            this.indexLeadSelected = index
            this.filtroLeadSelected = this.arrLeads[index]
            this.$emit('changeFiltroLeads', this.filtroLeadSelected.id)
        },

        handleChangeOrgs (index) {
            this.indexOrgSelected = index
            this.filtroOrgSelected = this.arrOrgs[index]
            this.$emit('changeFiltroOrg', this.filtroOrgSelected.id)
        },

        handleChangeEquipe (index) {
            this.indexUsuarioSelected = 0
            this.indexEquipeSelected = index
            this.codequipe = this.arrEquipes[index].id
            if (this.codequipe == -1)
              this.codequipe = null
            this.$emit('changeEquipe', this.codequipe)
        },

        handleChangeFunil (index) {
            this.indexFunilSelected = index
            console.log(this.arrFunil[index])
            if (this.arrFunil[index].id == -1)
              this.handleNovoFunil()
            else
            if (this.arrFunil[index].id == -2)
              this.handleEditarFunil()
            else {
                this.funilSelected = this.arrFunil[index]
                this.$emit('changeFunil', this.funilSelected.id)
            }
        },

        preparaFiltro () {
            if (this.funilList) {
                for (var x = 0; x < this.funilList.length; x++) {
                    this.arrFunil.push({ id: this.funilList[x].codfunil, label: this.funilList[x].descricao })
                }
                if (!this.codfunil && this.funilList.length > 0)
                    this.codfunil = this.funilList[0].codfunil
            }

            
            //monta a lista de usuarios e equipes
            this.arrUsuarios = [ { id: -1, label: 'Todos' } ]
            for (var x = 0; x < this.usuarioList.length; x++) {
                this.arrUsuarios.push({ id: this.usuarioList[x].codusuario, label: this.usuarioList[x].nome })
            }

            this.arrEquipes = [ { id: -1, label: 'Todas' } ]
            if (this.equipeList.length > 0) {
                for (var x = 0; x < this.equipeList.length; x++) {
                    this.arrEquipes.push({ id: this.equipeList[x].codequipe, label: this.equipeList[x].nome })
                }
            }

        },

    },

    created () {
        this.preparaFiltro()
    }

}

</script>

<template>
    <div class="row align-items-center">
        <div class="col-12">
            <span v-if="showFunil" class="lbl" >Funil
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ funilLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in arrFunil" :key="index" 
                            @click="handleChangeFunil(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span v-if="showNegocios" class="lbl" >Negócios
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelNegocios }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in arrNegocios" :key="index" 
                            @click="handleChangeFiltro(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span v-if="showPessoas" class="lbl" >Contatos
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelContato }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in arrContatos" :key="index" 
                            @click="handleChangeContatos(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span v-if="showLeads" class="lbl" >Leads
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelContato }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in arrLeads" :key="index" 
                            @click="handleChangeLeads(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span v-if="showOrganizacao" class="lbl" >Organizações
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelOrg }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in arrOrgs" :key="index" 
                            @click="handleChangeOrgs(index)">{{ filtro.label }}</a>
                    </div>
            </span>
            <span class="lbl" >Usuário
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ usuarioLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in arrUsuarios" :key="index" 
                            @click="handleChangeUsuario(index)">{{ item.label }}</a>
                    </div>
            </span>
            <span class="lbl pl-3" >Equipe
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ equipeLabel }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(item, index) in arrEquipes" :key="index" 
                            @click="handleChangeEquipe(index)">{{ item.label }}</a>
                    </div>
            </span>
        </div>
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-filtros-negocio.vue